/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const tableData = {
    gridOptions: {
      pagination: true,
      rowHeight: 50,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        floatingFilter: true,
        unSortIcon: true,
      },
    },
    columnDefs: [
      {
        type: "default",
        compProps: {
          headerName: "Email",
          field: "email",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      {
        type: "default",
        compProps: {
          headerName: "Name",
          field: "name",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      {
        type: "default",
        compProps: {
          headerName: "Role",
          field: "role",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      {
        type: "default",
        compProps: {
          headerName: "Status",
          field: "status",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      // {
      //   type: "default",
      //   compProps: {
      //     headerName: "Action",
      //     field: "date",
      //     filter: "agTextColumnFilter",
      //     editable: false,
      //     minWidth: 110,
      //   },
      //   valueStyle: {
      //     color: "#1a4677",
      //   },
      // },
      // {
      //   type: "default",
      //   compProps: {
      //     headerName: "Signatures",
      //     field: "signature",
      //     filter: "agTextColumnFilter",
      //     editable: false,
      //     minWidth: 110,
      //   },
      //   valueStyle: {
      //     color: "#1a4677",
      //   },
      // },
      // {
      //   type: "default",
      //   compProps: {
      //     headerName: "Serial #",
      //     field: "serial",
      //     filter: "agTextColumnFilter",
      //     editable: false,
      //     minWidth: 110,
      //   },
      //   valueStyle: {
      //     color: "#1a4677",
      //   },
      // },
      // {
      //   type: "default",
      //   compProps: {
      //     headerName: "Grade",
      //     field: "grade",
      //     filter: "agTextColumnFilter",
      //     editable: false,
      //     minWidth: 110,
      //   },
      //   valueStyle: {
      //     color: "#1a4677",
      //   },
      // },
      // {
      //   type: "default",
      //   compProps: {
      //     headerName: "WBG #",
      //     field: "wbg",
      //     filter: "agTextColumnFilter",
      //     editable: false,
      //     minWidth: 110,
      //   },
      //   valueStyle: {
      //     color: "#1a4677",
      //   },
      // },
      {
        type: "button",
        compProps: {
          headerName: "Action",
          field: "more",
          // resizable: false,
          // suppressSizeToFit: true,
          // pinned: "right",
          width: 100,
          minWidth: 110
        },
        typeProps: [
          {
            title: "View",
            value: "View",
            type: "outline",
            buttonStyle: {
              width: 70,
              height: 30,
              borderColor: "#1a4677",
            },
            titleStyle: {
              fontSize: 12,
              color: "#1a4677",
            },
          },
        ],
        valueStyle: {
          color: "#1a4677",
        },
      },
    ],
    rowData: [
      {
        email: "nitikshakatoch@gmail.com",
        name: "Nitiksha Katoch",
        role: "Intern",
        status: "Onboard",
        // date: "1986",
        // signature: "Bentsen/A.P. Dam",
        // serial: "0232855",
        // grade: "66 TOP UNC Gem",
        // wbg: "0111883",
        more: "View",
      },
    ],
  };
  
  
  
  
  
  
  
  
  
  